"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
var InstructorDocumentsIndexController = /** @class */ (function () {
    function InstructorDocumentsIndexController($scope, $q, UserService, VueStoreFactory, FlashService) {
        this.$scope = $scope;
        this.$q = $q;
        this.UserService = UserService;
        this.VueStoreFactory = VueStoreFactory;
        this.FlashService = FlashService;
        this.pendingDocuments = [];
        this.completedDocuments = [];
        this.loading = true;
        this.error = null;
        this.activeTab = "pending";
        this.downloadingId = null;
        this.currentUser = UserService.getCurrentUser();
        this.init();
    }
    InstructorDocumentsIndexController.prototype.init = function () {
        var _this = this;
        this.loading = true;
        this.$q.all([
            this.VueStoreFactory.dispatch("documents/GET_DOCUMENTS_BY_STATUS", {
                status: "pending",
                user_id: this.currentUser.id,
            }),
            this.VueStoreFactory.dispatch("documents/GET_DOCUMENTS_BY_STATUS", {
                status: "in_progress",
                user_id: this.currentUser.id,
            }),
            this.VueStoreFactory.dispatch("documents/GET_DOCUMENTS_BY_STATUS", {
                status: "completed",
                user_id: this.currentUser.id,
            }),
        ]).then(function (_a) {
            var pending = _a[0], inProgress = _a[1], completed = _a[2];
            _this.pendingDocuments = __spreadArray(__spreadArray([], (pending || []), true), (inProgress || []), true);
            _this.completedDocuments = completed || [];
        }).catch(function (err) {
            console.error("Error loading documents:", err);
            _this.error = "Failed to load documents";
        }).finally(function () {
            _this.loading = false;
        });
    };
    InstructorDocumentsIndexController.prototype.setActiveTab = function (tab) {
        this.activeTab = tab;
    };
    InstructorDocumentsIndexController.prototype.downloadFlattenedPdf = function (doc) {
        return __awaiter(this, void 0, void 0, function () {
            var pdfData, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.downloadingId)
                            return [2 /*return*/];
                        this.downloadingId = doc.id;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        return [4 /*yield*/, this.VueStoreFactory.dispatch("documents/GET_FLATTENED_PDF", doc.id)];
                    case 2:
                        pdfData = _a.sent();
                        if (pdfData && pdfData.file_url) {
                            window.open(pdfData.file_url, "_blank");
                        }
                        else {
                            this.FlashService.setMessage({
                                type: "error",
                                message: "Completed PDF not yet available. Please try again later.",
                            });
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        err_1 = _a.sent();
                        console.error("Error downloading flattened PDF:", err_1);
                        this.FlashService.setMessage({
                            type: "error",
                            message: "Failed to download completed PDF.",
                        });
                        return [3 /*break*/, 5];
                    case 4:
                        this.downloadingId = null;
                        this.applyScope();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    InstructorDocumentsIndexController.prototype.applyScope = function () {
        if (!this.$scope.$$phase) {
            this.$scope.$apply();
        }
    };
    InstructorDocumentsIndexController.$inject = ["$scope", "$q", "UserService", "VueStoreFactory", "FlashService"];
    return InstructorDocumentsIndexController;
}());
exports.default = InstructorDocumentsIndexController;
